import type { MessagingGetChatRooms200PageAllOfThreeContentItemBasicInfoAllOfTwoType } from './messagingGetChatRooms200PageAllOfThreeContentItemBasicInfoAllOfTwoType';

/**
 * 채팅방 기본 정보
 */
export type MessagingGetChatRooms200PageAllOfThreeContentItemBasicInfoAllOfTwo = {
  name?: string;
  type?: MessagingGetChatRooms200PageAllOfThreeContentItemBasicInfoAllOfTwoType;
};
